import React, { useEffect } from 'react'
import { useTranslation } from "react-i18next";
import './NotAuth.css'
import { AuthenticationService } from "../../services/authentication.service";

const NotAuth = (props) => {
  const authenticationService = new AuthenticationService();
  const [ t, i18n ] = useTranslation("global");
  
  useEffect(() => {
	  const userBrowserLang = getUserBrowserLanguage();
	  authenticationService.setAuthenticationSession(null);
	  i18n.changeLanguage(userBrowserLang);
  }, [i18n]);
  
  const getUserBrowserLanguage = () => {
        const lang = window.navigator.language;

        if (lang.includes("es")) return "es";
        if (lang.includes("ca")) return "ca";
        if (lang.includes("en")) return "en";

        return "en";
  };
	
  return (
	  <div className={'mainNotFoundContainer'}>
		  <div className="login-form">
			  <div className="login-logo">
				  <a href={t("app.baseURL")}><img src={require("../../assets/img/logo.png")} alt="Login Logo" /></a>
			  </div>
			  <h1>{t('app.error.pageNotAuthTitle')}</h1>
		  	  <p>{t('app.error.pageNotAuthBody')}</p>
		  	  <a href={t('app.baseURL')}>{t('app.error.pageNotAuthLinkText')}</a>
		  </div>
		  
	  </div>
  )
}

export default NotAuth